module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/spina-me/source/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1